import React, { Fragment } from "react";
import PropTypes from "prop-types";
import * as types from "../../../constants/ComponentConstants";
import { AdresTypes } from "../../../constants/DomainConstants";
import Section from "../../common/Section";
import CheckBoxWithChild from "../../common/CheckBoxWithChild";
import Row from "../../common/Row";
import Form from "../../common/Form";
import Col from "../../common/Col";
import Fieldset from "../../common/Fieldset";
import ConfirmModal from "../../common/ConfirmModal";
import AdresInput from "../../common/AdresInput";

const AdresEditForm = (props) => {
    const {
        model,
        errors,
        onSave,
        onChange,
        onCancel,
        disabled,
        landen,
        postcodeGemeenten,
        straten,
        huisnummers,
        adresTypes,
        beschrCorrespAdressen,
        showUnknownToPartnerModal,
        showUnsavedChangesAdresModal,
        confirmUnknownAdres,
        confirmUnsavedChangesAdresEdit,
        closeUnknownAdresModal,
        closeUnsavedChangesAdresEditModal,
        modelContainsMaatschappelijkeZetel
    } = props;

    const availableAdresTypes = modelContainsMaatschappelijkeZetel && model.soortAdres !== AdresTypes.MAATSCHAPPELIJKE_ZETEL ? adresTypes.filter(x => x.value !== AdresTypes.MAATSCHAPPELIJKE_ZETEL) : adresTypes;

    return (
        <Section
            title={"Adresgegevens"}
            color={types.COLOR_GREEN_LIGHT}>
            {showUnsavedChangesAdresModal ? <ConfirmModal
                isOpen={showUnsavedChangesAdresModal}
                title="Onbewaarde wijzigingen"
                mainText={"Het huidig formulier-gedeelte bevat nog niet bewaarde wijzigingen. Ben je zeker dat je wil verder gaan, en de wijzigingen verliest?"}
                confirmAction={confirmUnsavedChangesAdresEdit}
                cancelAction={closeUnsavedChangesAdresEditModal}
                confirmText="Ga verder"
                cancelText="Terug"
            /> : null}
            <Form name="adressen"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Ga verder"
                onRightButtonClick={onSave}
                rightButtonDisabled={disabled || (model.isNew && !model['tempSoortAdres1'] && !model['tempSoortAdres2'] && !model['tempSoortAdres3'])}
                leftButtonLabel="Annuleer"
                leftButtonDisabled={disabled}
                onLeftButtonClick={onCancel}
            >
                <Fieldset>

                    {!model.isNew ?
                        <Row><Col size={4}><label>Soort adres: <b>{adresTypes.find(x => x.value == model.soortAdres).label}</b></label></Col></Row>
                        : <Row>
                            <Fragment>
                                <Col size={2}>Soort adres:</Col>
                                {availableAdresTypes.map(item =>
                                    <Col size={3} key={"tempSoortAdres" + item.value}>
                                        <CheckBoxWithChild
                                            key={"tempSoortAdres" + item.value}
                                            name={"tempSoortAdres" + item.value}
                                            value={model["tempSoortAdres" + item.value]}
                                            label={item.label}
                                            onChange={onChange} />
                                    </Col>)}
                            </Fragment>
                        </Row>}

                    <AdresInput
                        model={model}
                        landen={landen}
                        postcodeGemeenten={postcodeGemeenten}
                        straten={straten}
                        huisnummers={huisnummers}
                        beschrCorrespAdressen={beschrCorrespAdressen}
                        onChange={onChange}
                        errors={errors}
                        showUnknownToPartnerModal={showUnknownToPartnerModal}
                        confirmUnknownAdres={confirmUnknownAdres}
                        closeUnknownAdresModal={closeUnknownAdresModal}
                        isCorrespondentieAdres={model["tempSoortAdres2"] || model.soortAdres === AdresTypes.CORRESPONDENTIEADRES}
                        isExploitatatieAdres={model["tempSoortAdres3"] || model.soortAdres === AdresTypes.EXPLOITATIEADRES}
                    />
                </Fieldset>
            </Form>
        </Section>
    );
};

AdresEditForm.propTypes = {
    model: PropTypes.object,
    errors: PropTypes.object,
    onSave: PropTypes.func,
    onChange: PropTypes.func,
    onCancel: PropTypes.func,
    disabled: PropTypes.bool,
    landen: PropTypes.array,
    postcodeGemeenten: PropTypes.array,
    gemeenten: PropTypes.array,
    straten: PropTypes.array,
    huisnummers: PropTypes.array,
    busnummers: PropTypes.array,
    adresTypes: PropTypes.array,
    beschrCorrespAdressen: PropTypes.array,
    showUnknownToPartnerModal: PropTypes.bool,
    showUnsavedChangesAdresModal: PropTypes.bool,
    confirmUnknownAdres: PropTypes.func,
    confirmUnsavedChangesAdresEdit: PropTypes.func,
    closeUnknownAdresModal: PropTypes.func,
    closeUnsavedChangesAdresEditModal: PropTypes.func,
    modelContainsMaatschappelijkeZetel: PropTypes.bool
};

export default AdresEditForm;